import { EquipmentResponse } from './equipments.types'

export const mockTractor: EquipmentResponse = {
  equipmentId: 0,
  equipmentType: 'TRACTOR',
  unitNumber: '',
  address: '',
}

export const mockTrailer: EquipmentResponse = {
  equipmentId: 0,
  equipmentType: 'TRAILER',
  unitNumber: '',
  address: '',
}
